import { getRoutes } from '@ui-framework/index';
import PublicHelp from './pages/public/index';
import PublicHelpDetail from './pages/public/detail';
import Help from './pages/loggedin/index';
import HelpDetail from './pages/loggedin/detail';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

const Pages = ProtectedRoute => ({
  Help: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={Help}
    />
  ),
  HelpDetail: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={HelpDetail}
    />
  ),
  PublicHelp: <PublicHelp />,
  PublicHelpDetail: <PublicHelpDetail />,
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = () => [];

export { PublicHelp, PublicHelpDetail, Help, HelpDetail, routes, stores };
